import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import { ColumnFiltersState } from "@tanstack/react-table";


interface ShedState {
    currentShedAudit: ShedAudit[] | [];
    elements: ShedElement[];
    currentPage: number;
    rowsPerPage: number;
    error: null | string;
    totalRows: number;
    sort: string[];
    loading: boolean;
    filter: { [key: string]: any};
}

export interface boxes {
    _id: string,
    name: string;
    maxCapacity: number;
}

export interface ShedElement {
    _id?: string,
    name: string,
    boxes: boxes[],
    microchipeCodeForShed?: string[]
}

const initialState: ShedState = {
    currentShedAudit: [],
    elements: [],
    currentPage: 0,
    rowsPerPage: 10,
    error: null,
    totalRows: 0,
    sort: ['dateCreated', 'asc'],
    loading: false,
    filter: {},
}

export interface GetAllElementPayloadShed {
    pageableDto: PageableDto;
    filters: ColumnFiltersState | null
}

export interface ShedAudit {
    action: string;
    oldValue: string;
    newValue: ShedElement;
    timestamp: ShedElement;
    username: string;
}

interface PageableDto {
    page: number;
    size: number;
    sort: string[];
}

export const Shed = createSlice({
    name: "shed",
    initialState,
    reducers: {

        shedAction: (state, action: PayloadAction<string>) => {
            state.loading = true;
            state.error = null;
        },
        shedActionSuccess: (state, action:PayloadAction<ShedAudit[]>) => {
            state.loading = false;
            state.error = null;
            state.currentShedAudit = action.payload;
        },
        shedActionError: (state) => {
            state.loading = false;
            state.error = 'Failed to perform shed action';
        },

        getAllElement: (state, action: PayloadAction<GetAllElementPayloadShed>) => {
            state.loading = true;
        },
        getAllElementSuccess: (
            state,
            action: PayloadAction<{ data: ShedElement[]; currentPage: number; totalRows: number }>
        ) => {
            state.elements = action.payload.data;
            state.currentPage = action.payload.currentPage;
            state.totalRows = action.payload.totalRows;
            state.loading = false;
        },
        getAllElementError: (state) => {
        },

        setPage: (state, action: PayloadAction<number>) => {
            state.currentPage = action.payload;
        },
        setRowsPerPage: (state, action: PayloadAction<number>) => {
            state.rowsPerPage = action.payload;
        },
        setSort: (state, action: PayloadAction<string[]>) => {
            state.sort = action.payload;
        },

        setFilter: (state, action: PayloadAction<{ [key: string]: any}>) =>{
            state.filter = action.payload;
            state.filter = filterData(state.elements, state.filter);
        },
        filterElement: (state, action: PayloadAction<{ [key: string]: any }>) =>{
            state.loading = true;
        },
        
        filterElementSuccess: (state, action: PayloadAction<{ data: ShedElement[], currentPage: number, totalRows: number}>) =>{
            state.filter = action.payload.data;
            state.currentPage = action.payload.currentPage;
            state.totalRows = action.payload.totalRows;
            state.loading = false;
        },

        filterElementError: (state) => {
            state.loading = false;
            state.error = "Error applying filter.";
        },


        getAllElementShedNotPageable: (state) => {},
        getAllElementSuccessShedNotPageable: (state, action: PayloadAction<ShedElement[]>) => {
            state.elements = action.payload;
            state.filter = action.payload;
        },
        getAllElementErrorShedNotPageable: (state) => {
            state.loading = false;
        },

        saveElement: (state, action: PayloadAction<{ shed:  ShedElement, callback: () => void  }>) => {
            state.loading = true;
        },

        saveElementSuccess: (state, action: PayloadAction<ShedElement>) => {
            state.elements.push(action.payload);
            //state.filter.push(action.payload);
        },

        saveElementError: (state, action: PayloadAction<ShedElement>) => {
            state.loading = false;
        },

        saveElementShed:(state , action: PayloadAction<ShedElement>) => {},
        saveElementShedSuccess:(state , action: PayloadAction<ShedElement>) => {
             const payload = {
                 ...action.payload
             }
 
            state.elements.push(payload);
            state.filter.push(payload); // Add to both elements and filter
 
        },
        saveElementShedError:(state, action: PayloadAction<ShedElement>) => {
            state.loading = false;
        },

        updateElement: (state, action: PayloadAction<{ shed:  ShedElement, callback: () => void  }>) => {
            state.loading = true;

        },
        updateElementSuccess: (state, action: PayloadAction<ShedElement>) => {
            let index = state.elements.findIndex(element => element._id === action.payload._id);
            // if (index !== -1) {}
                state.elements[index] = action.payload;
                state.filter[index] = action.payload;
            
        },
        updateElementError: (state) => {state.loading = false;},

          // update di user da parte di Admin
          updateElementAdmin: (state, actions: PayloadAction<ShedElement>) => {},
          updateElementSuccessAdmin: (state, actions: PayloadAction<ShedElement>) => {
              let index = state.elements.findIndex(element => element._id === actions.payload._id);
              state.elements[index] = actions.payload;
              state.filter[index] = actions.payload;
          },
          updateElementErrorAdmin: (state) => {
              state.loading = false;
          },


        deleteElement: (state, action: PayloadAction<{ id: string, callback: () => void }>) => {},
        deleteElementSuccess: (state, action: PayloadAction<string>) => {
            state.elements = state.elements.filter(el => el._id !== action.payload);
        },
        deleteElementError: (state) => {
            state.loading = false;
        },


    }
})

const filterData = (data: ShedElement[], filter: { [key: string]: any }) => {
    return data.filter(element => {
        for (const key in filter) {
            if (filter.hasOwnProperty(key)) {

                const elementValue = element[key as keyof ShedElement];
                const filterValue = filter[key];


                if (filterValue !== undefined && filterValue !== null && elementValue !== filterValue) {
                    return false;
                }
            }
        }
        return true;
    });
};

export const {
    getAllElement,
    getAllElementErrorShedNotPageable,
    getAllElementShedNotPageable,
    getAllElementSuccessShedNotPageable,
    getAllElementSuccess,
    getAllElementError,
    saveElementShedError,
    saveElementShedSuccess,
    saveElementShed,
    saveElement,
    saveElementSuccess,
    saveElementError,
    updateElement,
    updateElementSuccess,
    updateElementError,
    deleteElement,
    deleteElementSuccess,
    deleteElementError,
    setRowsPerPage,
    setSort,
    setPage,
    filterElement,
    filterElementSuccess,
    filterElementError,
    setFilter,
    updateElementAdmin,
    updateElementErrorAdmin,
    updateElementSuccessAdmin,
    shedActionError,
    shedActionSuccess,
    shedAction
} = Shed.actions

export default Shed.reducer